module.exports = __webpack_public_path__ + "static/media/IS.1eecf71d.svg";